import { useRouter } from 'next/router'

const useSnowOnPage = () => {
  const router = useRouter()

  return router.asPath.includes('/bladdra/jul') ||
    router.asPath.includes('/barn')
    ? router.pathname
    : ''
}

export default useSnowOnPage
